export function normalizeCategoriesResponse(
  response: any,
  postIds: string[],
): { [postId: string]: number[] } {
  // * Case 1: Response is {"categories":[]} -> Normalize to { postId: [] }
  // * Case 2: Already normalized object per postId -> { postId: [categoryId, categoryId, categoryId]}
  if (Array.isArray(response)) {
    return Object.fromEntries(postIds.map((id) => [id, []]));
  }

  return response ?? {};
}
